import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useRouteMatch, Link } from "react-router-dom";
import Button from "../Shared/Button";
import { fetchPractitionerToStaff, updateRelationshipOfCaseManagerAndStaff } from "../../services/caseManager";
import { getUsers } from "../../services/auth";
import { ADMIN_ROLE } from "../../constants";

const mapStateToProps = (state) => ({
  practitioners: state.app.practitioners,
});

const RelationshipPanel = ({ practitioners }) => {
  const { url } = useRouteMatch();
  const [practitionerArray, setPractitionerArray] = useState([]);
  const [practitionerToStaff, setPractitionerToStaff] = useState([]);
  const [selectedPractitionerId, setSelectedPractitionerId] = useState("");
  const [selectedStaff, setSelectedStaff] = useState({ label: "", value: "" });

  const [staffUpdated, setStaffUpdated] = useState(true);
  const [isUpdatingStaff, setIsUpdatingStaff] = useState(false);

  const [notification, setNotification] = useState(null);

  useEffect(() => {
    setPractitionerArray(practitioners);
  }, [practitioners]);

  useEffect(() => {
    fetchPractitionerToStaff((data) => {
      setPractitionerToStaff({ ...data });
    });
  }, []);

  const [coordinators, setCoordinators] = useState([]);

  useEffect(() => {
    async function fetchUsers() {
      const users = await getUsers(ADMIN_ROLE);
      setCoordinators(
        (users?.filter((user) => !user.isITStaff && !user.disabled) || []).map((user) => ({
          label: `${user.firstName} ${user.lastName}`,
          value: user.shortName,
        }))
      );
    }

    fetchUsers();
  }, []);

  const handleSubmit = async () => {
    if (!_.isNull(notification)) {
      setNotification(null);
    }
    setIsUpdatingStaff(true);
    const result = await updateRelationshipOfCaseManagerAndStaff({
      practitionerId: selectedPractitionerId,
      staff: selectedStaff.value,
    });
    if (result.error) {
      setNotification({
        success: false,
        message: "Something went wrong, please try again later!",
      });
    } else {
      setNotification({
        success: true,
        message: "Update templates successfully!",
      });
      setStaffUpdated(false);
    }
    setIsUpdatingStaff(false);
  };

  return (
    <div className="columns">
      <div className="column is-one-fifth">
        <aside className="menu">
          <p className="menu-label">Case Manager</p>
          <ul className="menu-list">
            {practitionerArray.map(({ firstName, lastName, practitionerId: practitionerIdFromPractitionerArray }) => (
              <li key={practitionerIdFromPractitionerArray} className="is-size-7">
                <Link
                  key={practitionerIdFromPractitionerArray}
                  to={url}
                  className={
                    selectedPractitionerId === practitionerIdFromPractitionerArray ? "is-active is-radiusless" : ""
                  }
                  onClick={() => {
                    const staff = practitionerToStaff[practitionerIdFromPractitionerArray];
                    setSelectedPractitionerId(practitionerIdFromPractitionerArray);
                    setSelectedStaff({ label: staff, value: staff } || { label: "", value: "" });
                    setStaffUpdated(true);
                    setNotification(null);
                  }}
                >
                  {`${firstName} ${lastName}`}
                </Link>
              </li>
            ))}
          </ul>
        </aside>
      </div>
      <div className="column is-half">
        <p className="menu-label">STAFF</p>
        {selectedPractitionerId !== "" && (
          <ul className="menu-list">
            {coordinators.map(({ label, value }) => (
              <li key={value} className="is-size-7">
                <Link
                  key={value}
                  to={url}
                  className={selectedStaff.value === value ? "is-active is-radiusless" : ""}
                  onClick={() => setSelectedStaff({ label, value })}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        )}
        {selectedPractitionerId !== "" && (
          <Button
            className=""
            text="SUBMIT"
            onClick={handleSubmit}
            isLoading={isUpdatingStaff}
            disabled={!staffUpdated}
          />
        )}
        {!_.isNull(notification) && (
          <div
            className={`notification is-light is-size-7 is-radiusless ${
              notification.success ? "is-success" : "is-danger"
            }`}
          >
            {notification.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(RelationshipPanel);
